export const ACTION_CREER = 'creer';
export const ACTION_DUPLIQUER = 'dupliquer';
export const EXPORT_EXCEL_TYPE_TAXATION_TLPE = 'typeTaxationTlpe';
